/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ period: NonNullable<unknown> }} Wrapped_Period_Volume_FirstInputs */

const en_us2_wrapped_period_volume_first = /** @type {(inputs: Wrapped_Period_Volume_FirstInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`Your first month with volume logged.`);
	return /** @type {LocalizedString} */ (`Your first year with volume logged.`)
	
};

const pt_br2_wrapped_period_volume_first = /** @type {(inputs: Wrapped_Period_Volume_FirstInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`Seu primeiro mês com volume registrado.`);
	return /** @type {LocalizedString} */ (`Seu primeiro ano com volume registrado.`)
	
};

const es_419_wrapped_period_volume_first = /** @type {(inputs: Wrapped_Period_Volume_FirstInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`Tu primer mes con volumen registrado.`);
	return /** @type {LocalizedString} */ (`Tu primer año con volumen registrado.`)
	
};

const pt_pt2_wrapped_period_volume_first = /** @type {(inputs: Wrapped_Period_Volume_FirstInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`O teu primeiro mês com volume registado.`);
	return /** @type {LocalizedString} */ (`O teu primeiro ano com volume registado.`)
	
};

const fr_fr2_wrapped_period_volume_first = /** @type {(inputs: Wrapped_Period_Volume_FirstInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`Ton premier mois avec du volume enregistré.`);
	return /** @type {LocalizedString} */ (`Ta première année avec du volume enregistré.`)
	
};

const de_de2_wrapped_period_volume_first = /** @type {(inputs: Wrapped_Period_Volume_FirstInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`Dein erster Monat mit eingetragenem Volumen.`);
	return /** @type {LocalizedString} */ (`Dein erstes Jahr mit eingetragenem Volumen.`)
	
};

const it_it2_wrapped_period_volume_first = /** @type {(inputs: Wrapped_Period_Volume_FirstInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`Il tuo primo mese con volume registrato.`);
	return /** @type {LocalizedString} */ (`Il tuo primo anno con volume registrato.`)
	
};

/**
* | period | output |
* | --- | --- |
* | "month" | "Your first month with volume logged." |
* | * | "Your first year with volume logged." |
*
* @param {Wrapped_Period_Volume_FirstInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_period_volume_first = /** @type {((inputs: Wrapped_Period_Volume_FirstInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Period_Volume_FirstInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_period_volume_first(inputs)
	if (locale === "es-419") return es_419_wrapped_period_volume_first(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_period_volume_first(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_period_volume_first(inputs)
	if (locale === "de-DE") return de_de2_wrapped_period_volume_first(inputs)
	if (locale === "it-IT") return it_it2_wrapped_period_volume_first(inputs)
	return en_us2_wrapped_period_volume_first(inputs)
});
export { wrapped_period_volume_first as "wrapped-period.volume_first" }